var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Emitter } from "./event";
var List = /** @class */ (function () {
    function List() {
        this.list = [];
        this._selectedIndex = -1;
        this._onSplice = new Emitter();
        this.onSplice = this._onSplice.event;
        this._onSelectionChanged = new Emitter();
        this.onSelectionChanged = this._onSelectionChanged.event;
    }
    Object.defineProperty(List.prototype, "length", {
        get: function () {
            return this.list.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(List.prototype, "selectedIndex", {
        get: function () {
            return this._selectedIndex;
        },
        enumerable: false,
        configurable: true
    });
    List.prototype.splice = function (start, deleteCount) {
        var _a;
        var items = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            items[_i - 2] = arguments[_i];
        }
        var deleted = (_a = this.list).splice.apply(_a, __spreadArray([start, deleteCount], __read(items)));
        this._onSplice.fire(start);
        return deleted;
    };
    List.prototype.setSelected = function (index) {
        if (this._selectedIndex === index) {
            return;
        }
        this._selectedIndex = index;
        this._onSelectionChanged.fire();
    };
    List.prototype.isSelected = function (index) {
        return this.selectedIndex === index;
    };
    List.prototype.getItem = function (index) {
        return this.list[index];
    };
    List.prototype.dispose = function () {
        this._onSplice.dispose();
        this._onSelectionChanged.dispose();
    };
    return List;
}());
export { List };
